export default __webpack_public_path__ + "static/media/transactionProcessing.ee9e5038.svg";